(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(".clay-quantity-grid-table-container {\n  width: 100%;\n}\n\n.clay-quantity-grid-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  /* font-size: 13px; */\n  border: 1px solid #242833bf;\n  margin-bottom: 8px;\n  margin-top: 12px;\n}\n\n.clay-quantity-grid-table thead th {\n  border-bottom: 1px solid #242833bf;\n  padding: 8px;\n  text-align: left;\n  font-weight: normal;\n  /* background-color: #f0f0f0; */\n}\n\n.clay-quantity-grid-table tbody td {\n  padding: 8px;\n  border-bottom: 1px solid #242833bf;\n}\n\n.clay-quantity-grid-table tbody tr:last-child td {\n  border-bottom: none;\n}"));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
!function() {
  "use strict";
  var e, t, r, n, a, i, o, c, l, s, u, p = {}, d = [], y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, _ = Array.isArray;
  function f(e2, t2) {
    for (var r2 in t2) e2[r2] = t2[r2];
    return e2;
  }
  function m(e2) {
    e2 && e2.parentNode && e2.parentNode.removeChild(e2);
  }
  function g(e2, n2, a2, i2, o2) {
    var c2 = { type: e2, props: n2, key: a2, ref: i2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: null == o2 ? ++r : o2, __i: -1, __u: 0 };
    return null == o2 && null != t.vnode && t.vnode(c2), c2;
  }
  function h(e2) {
    return e2.children;
  }
  function v(e2, t2) {
    this.props = e2, this.context = t2;
  }
  function x(e2, t2) {
    if (null == t2) return e2.__ ? x(e2.__, e2.__i + 1) : null;
    for (var r2; t2 < e2.__k.length; t2++) if (null != (r2 = e2.__k[t2]) && null != r2.__e) return r2.__e;
    return "function" == typeof e2.type ? x(e2) : null;
  }
  function P(e2) {
    var t2, r2;
    if (null != (e2 = e2.__) && null != e2.__c) {
      for (e2.__e = e2.__c.base = null, t2 = 0; t2 < e2.__k.length; t2++) if (null != (r2 = e2.__k[t2]) && null != r2.__e) {
        e2.__e = e2.__c.base = r2.__e;
        break;
      }
      return P(e2);
    }
  }
  function F(e2) {
    (!e2.__d && (e2.__d = true) && n.push(e2) && !$.__r++ || a !== t.debounceRendering) && ((a = t.debounceRendering) || i)($);
  }
  function $() {
    for (var e2, r2, a2, i2, c2, l2, s2, u2 = 1; n.length; ) n.length > u2 && n.sort(o), e2 = n.shift(), u2 = n.length, e2.__d && (a2 = void 0, c2 = (i2 = (r2 = e2).__v).__e, l2 = [], s2 = [], r2.__P && ((a2 = f({}, i2)).__v = i2.__v + 1, t.vnode && t.vnode(a2), q(r2.__P, a2, i2, r2.__n, r2.__P.namespaceURI, 32 & i2.__u ? [c2] : null, l2, null == c2 ? x(i2) : c2, !!(32 & i2.__u), s2), a2.__v = i2.__v, a2.__.__k[a2.__i] = a2, R(l2, a2, s2), a2.__e != c2 && P(a2)));
    $.__r = 0;
  }
  function b(e2, t2, r2, n2, a2, i2, o2, c2, l2, s2, u2) {
    var y2, _2, f2, m2, g2, h2, v2 = n2 && n2.__k || d, x2 = t2.length;
    for (l2 = T(r2, t2, v2, l2, x2), y2 = 0; y2 < x2; y2++) null != (f2 = r2.__k[y2]) && (_2 = -1 === f2.__i ? p : v2[f2.__i] || p, f2.__i = y2, h2 = q(e2, f2, _2, a2, i2, o2, c2, l2, s2, u2), m2 = f2.__e, f2.ref && _2.ref != f2.ref && (_2.ref && E(_2.ref, null, f2), u2.push(f2.ref, f2.__c || m2, f2)), null == g2 && null != m2 && (g2 = m2), 4 & f2.__u || _2.__k === f2.__k ? l2 = w(f2, l2, e2) : "function" == typeof f2.type && void 0 !== h2 ? l2 = h2 : m2 && (l2 = m2.nextSibling), f2.__u &= -7);
    return r2.__e = g2, l2;
  }
  function T(e2, t2, r2, n2, a2) {
    var i2, o2, c2, l2, s2, u2 = r2.length, p2 = u2, d2 = 0;
    for (e2.__k = new Array(a2), i2 = 0; i2 < a2; i2++) null != (o2 = t2[i2]) && "boolean" != typeof o2 && "function" != typeof o2 ? (l2 = i2 + d2, (o2 = e2.__k[i2] = "string" == typeof o2 || "number" == typeof o2 || "bigint" == typeof o2 || o2.constructor == String ? g(null, o2, null, null, null) : _(o2) ? g(h, { children: o2 }, null, null, null) : void 0 === o2.constructor && o2.__b > 0 ? g(o2.type, o2.props, o2.key, o2.ref ? o2.ref : null, o2.__v) : o2).__ = e2, o2.__b = e2.__b + 1, c2 = null, -1 !== (s2 = o2.__i = S(o2, r2, l2, p2)) && (p2--, (c2 = r2[s2]) && (c2.__u |= 2)), null == c2 || null === c2.__v ? (-1 == s2 && (a2 > u2 ? d2-- : a2 < u2 && d2++), "function" != typeof o2.type && (o2.__u |= 4)) : s2 != l2 && (s2 == l2 - 1 ? d2-- : s2 == l2 + 1 ? d2++ : (s2 > l2 ? d2-- : d2++, o2.__u |= 4))) : e2.__k[i2] = null;
    if (p2) for (i2 = 0; i2 < u2; i2++) null != (c2 = r2[i2]) && !(2 & c2.__u) && (c2.__e == n2 && (n2 = x(c2)), D(c2, c2));
    return n2;
  }
  function w(e2, t2, r2) {
    var n2, a2;
    if ("function" == typeof e2.type) {
      for (n2 = e2.__k, a2 = 0; n2 && a2 < n2.length; a2++) n2[a2] && (n2[a2].__ = e2, t2 = w(n2[a2], t2, r2));
      return t2;
    }
    e2.__e != t2 && (t2 && e2.type && !r2.contains(t2) && (t2 = x(e2)), r2.insertBefore(e2.__e, t2 || null), t2 = e2.__e);
    do {
      t2 = t2 && t2.nextSibling;
    } while (null != t2 && 8 == t2.nodeType);
    return t2;
  }
  function S(e2, t2, r2, n2) {
    var a2, i2, o2 = e2.key, c2 = e2.type, l2 = t2[r2];
    if (null === l2 && null == e2.key || l2 && o2 == l2.key && c2 === l2.type && !(2 & l2.__u)) return r2;
    if (n2 > (null == l2 || 2 & l2.__u ? 0 : 1)) for (a2 = r2 - 1, i2 = r2 + 1; a2 >= 0 || i2 < t2.length; ) {
      if (a2 >= 0) {
        if ((l2 = t2[a2]) && !(2 & l2.__u) && o2 == l2.key && c2 === l2.type) return a2;
        a2--;
      }
      if (i2 < t2.length) {
        if ((l2 = t2[i2]) && !(2 & l2.__u) && o2 == l2.key && c2 === l2.type) return i2;
        i2++;
      }
    }
    return -1;
  }
  function C(e2, t2, r2) {
    "-" == t2[0] ? e2.setProperty(t2, null == r2 ? "" : r2) : e2[t2] = null == r2 ? "" : "number" != typeof r2 || y.test(t2) ? r2 : r2 + "px";
  }
  function A(e2, t2, r2, n2, a2) {
    var i2;
    e: if ("style" == t2) if ("string" == typeof r2) e2.style.cssText = r2;
    else {
      if ("string" == typeof n2 && (e2.style.cssText = n2 = ""), n2) for (t2 in n2) r2 && t2 in r2 || C(e2.style, t2, "");
      if (r2) for (t2 in r2) n2 && r2[t2] === n2[t2] || C(e2.style, t2, r2[t2]);
    }
    else if ("o" == t2[0] && "n" == t2[1]) i2 = t2 != (t2 = t2.replace(c, "$1")), t2 = t2.toLowerCase() in e2 || "onFocusOut" == t2 || "onFocusIn" == t2 ? t2.toLowerCase().slice(2) : t2.slice(2), e2.l || (e2.l = {}), e2.l[t2 + i2] = r2, r2 ? n2 ? r2.t = n2.t : (r2.t = l, e2.addEventListener(t2, i2 ? u : s, i2)) : e2.removeEventListener(t2, i2 ? u : s, i2);
    else {
      if ("http://www.w3.org/2000/svg" == a2) t2 = t2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" != t2 && "height" != t2 && "href" != t2 && "list" != t2 && "form" != t2 && "tabIndex" != t2 && "download" != t2 && "rowSpan" != t2 && "colSpan" != t2 && "role" != t2 && "popover" != t2 && t2 in e2) try {
        e2[t2] = null == r2 ? "" : r2;
        break e;
      } catch (e3) {
      }
      "function" == typeof r2 || (null == r2 || false === r2 && "-" != t2[4] ? e2.removeAttribute(t2) : e2.setAttribute(t2, "popover" == t2 && 1 == r2 ? "" : r2));
    }
  }
  function k(e2) {
    return function(r2) {
      if (this.l) {
        var n2 = this.l[r2.type + e2];
        if (null == r2.u) r2.u = l++;
        else if (r2.u < n2.t) return;
        return n2(t.event ? t.event(r2) : r2);
      }
    };
  }
  function q(e2, r2, n2, a2, i2, o2, c2, l2, s2, u2) {
    var p2, d2, y2, g2, x2, P2, F2, T2, w2, S2, C2, $2, A2, k2, q2, R2, E2, D2 = r2.type;
    if (void 0 !== r2.constructor) return null;
    128 & n2.__u && (s2 = !!(32 & n2.__u), o2 = [l2 = r2.__e = n2.__e]), (p2 = t.__b) && p2(r2);
    e: if ("function" == typeof D2) try {
      if (T2 = r2.props, w2 = "prototype" in D2 && D2.prototype.render, S2 = (p2 = D2.contextType) && a2[p2.__c], C2 = p2 ? S2 ? S2.props.value : p2.__ : a2, n2.__c ? F2 = (d2 = r2.__c = n2.__c).__ = d2.__E : (w2 ? r2.__c = d2 = new D2(T2, C2) : (r2.__c = d2 = new v(T2, C2), d2.constructor = D2, d2.render = L), S2 && S2.sub(d2), d2.props = T2, d2.state || (d2.state = {}), d2.context = C2, d2.__n = a2, y2 = d2.__d = true, d2.__h = [], d2._sb = []), w2 && null == d2.__s && (d2.__s = d2.state), w2 && null != D2.getDerivedStateFromProps && (d2.__s == d2.state && (d2.__s = f({}, d2.__s)), f(d2.__s, D2.getDerivedStateFromProps(T2, d2.__s))), g2 = d2.props, x2 = d2.state, d2.__v = r2, y2) w2 && null == D2.getDerivedStateFromProps && null != d2.componentWillMount && d2.componentWillMount(), w2 && null != d2.componentDidMount && d2.__h.push(d2.componentDidMount);
      else {
        if (w2 && null == D2.getDerivedStateFromProps && T2 !== g2 && null != d2.componentWillReceiveProps && d2.componentWillReceiveProps(T2, C2), !d2.__e && (null != d2.shouldComponentUpdate && false === d2.shouldComponentUpdate(T2, d2.__s, C2) || r2.__v == n2.__v)) {
          for (r2.__v != n2.__v && (d2.props = T2, d2.state = d2.__s, d2.__d = false), r2.__e = n2.__e, r2.__k = n2.__k, r2.__k.some(function(e3) {
            e3 && (e3.__ = r2);
          }), $2 = 0; $2 < d2._sb.length; $2++) d2.__h.push(d2._sb[$2]);
          d2._sb = [], d2.__h.length && c2.push(d2);
          break e;
        }
        null != d2.componentWillUpdate && d2.componentWillUpdate(T2, d2.__s, C2), w2 && null != d2.componentDidUpdate && d2.__h.push(function() {
          d2.componentDidUpdate(g2, x2, P2);
        });
      }
      if (d2.context = C2, d2.props = T2, d2.__P = e2, d2.__e = false, A2 = t.__r, k2 = 0, w2) {
        for (d2.state = d2.__s, d2.__d = false, A2 && A2(r2), p2 = d2.render(d2.props, d2.state, d2.context), q2 = 0; q2 < d2._sb.length; q2++) d2.__h.push(d2._sb[q2]);
        d2._sb = [];
      } else do {
        d2.__d = false, A2 && A2(r2), p2 = d2.render(d2.props, d2.state, d2.context), d2.state = d2.__s;
      } while (d2.__d && ++k2 < 25);
      d2.state = d2.__s, null != d2.getChildContext && (a2 = f(f({}, a2), d2.getChildContext())), w2 && !y2 && null != d2.getSnapshotBeforeUpdate && (P2 = d2.getSnapshotBeforeUpdate(g2, x2)), R2 = p2, null != p2 && p2.type === h && null == p2.key && (R2 = N(p2.props.children)), l2 = b(e2, _(R2) ? R2 : [R2], r2, n2, a2, i2, o2, c2, l2, s2, u2), d2.base = r2.__e, r2.__u &= -161, d2.__h.length && c2.push(d2), F2 && (d2.__E = d2.__ = null);
    } catch (e3) {
      if (r2.__v = null, s2 || null != o2) if (e3.then) {
        for (r2.__u |= s2 ? 160 : 128; l2 && 8 == l2.nodeType && l2.nextSibling; ) l2 = l2.nextSibling;
        o2[o2.indexOf(l2)] = null, r2.__e = l2;
      } else for (E2 = o2.length; E2--; ) m(o2[E2]);
      else r2.__e = n2.__e, r2.__k = n2.__k;
      t.__e(e3, r2, n2);
    }
    else null == o2 && r2.__v == n2.__v ? (r2.__k = n2.__k, r2.__e = n2.__e) : l2 = r2.__e = I(n2.__e, r2, n2, a2, i2, o2, c2, s2, u2);
    return (p2 = t.diffed) && p2(r2), 128 & r2.__u ? void 0 : l2;
  }
  function R(e2, r2, n2) {
    for (var a2 = 0; a2 < n2.length; a2++) E(n2[a2], n2[++a2], n2[++a2]);
    t.__c && t.__c(r2, e2), e2.some(function(r3) {
      try {
        e2 = r3.__h, r3.__h = [], e2.some(function(e3) {
          e3.call(r3);
        });
      } catch (e3) {
        t.__e(e3, r3.__v);
      }
    });
  }
  function N(e2) {
    return "object" != typeof e2 || null == e2 ? e2 : _(e2) ? e2.map(N) : f({}, e2);
  }
  function I(r2, n2, a2, i2, o2, c2, l2, s2, u2) {
    var d2, y2, f2, g2, h2, v2, P2, F2 = a2.props, T2 = n2.props, w2 = n2.type;
    if ("svg" == w2 ? o2 = "http://www.w3.org/2000/svg" : "math" == w2 ? o2 = "http://www.w3.org/1998/Math/MathML" : o2 || (o2 = "http://www.w3.org/1999/xhtml"), null != c2) {
      for (d2 = 0; d2 < c2.length; d2++) if ((h2 = c2[d2]) && "setAttribute" in h2 == !!w2 && (w2 ? h2.localName == w2 : 3 == h2.nodeType)) {
        r2 = h2, c2[d2] = null;
        break;
      }
    }
    if (null == r2) {
      if (null == w2) return document.createTextNode(T2);
      r2 = document.createElementNS(o2, w2, T2.is && T2), s2 && (t.__m && t.__m(n2, c2), s2 = false), c2 = null;
    }
    if (null === w2) F2 === T2 || s2 && r2.data === T2 || (r2.data = T2);
    else {
      if (c2 = c2 && e.call(r2.childNodes), F2 = a2.props || p, !s2 && null != c2) for (F2 = {}, d2 = 0; d2 < r2.attributes.length; d2++) F2[(h2 = r2.attributes[d2]).name] = h2.value;
      for (d2 in F2) if (h2 = F2[d2], "children" == d2) ;
      else if ("dangerouslySetInnerHTML" == d2) f2 = h2;
      else if (!(d2 in T2)) {
        if ("value" == d2 && "defaultValue" in T2 || "checked" == d2 && "defaultChecked" in T2) continue;
        A(r2, d2, null, h2, o2);
      }
      for (d2 in T2) h2 = T2[d2], "children" == d2 ? g2 = h2 : "dangerouslySetInnerHTML" == d2 ? y2 = h2 : "value" == d2 ? v2 = h2 : "checked" == d2 ? P2 = h2 : s2 && "function" != typeof h2 || F2[d2] === h2 || A(r2, d2, h2, F2[d2], o2);
      if (y2) s2 || f2 && (y2.__html === f2.__html || y2.__html === r2.innerHTML) || (r2.innerHTML = y2.__html), n2.__k = [];
      else if (f2 && (r2.innerHTML = ""), b("template" === n2.type ? r2.content : r2, _(g2) ? g2 : [g2], n2, a2, i2, "foreignObject" == w2 ? "http://www.w3.org/1999/xhtml" : o2, c2, l2, c2 ? c2[0] : a2.__k && x(a2, 0), s2, u2), null != c2) for (d2 = c2.length; d2--; ) m(c2[d2]);
      s2 || (d2 = "value", "progress" == w2 && null == v2 ? r2.removeAttribute("value") : void 0 !== v2 && (v2 !== r2[d2] || "progress" == w2 && !v2 || "option" == w2 && v2 !== F2[d2]) && A(r2, d2, v2, F2[d2], o2), d2 = "checked", void 0 !== P2 && P2 !== r2[d2] && A(r2, d2, P2, F2[d2], o2));
    }
    return r2;
  }
  function E(e2, r2, n2) {
    try {
      if ("function" == typeof e2) {
        var a2 = "function" == typeof e2.__u;
        a2 && e2.__u(), a2 && null == r2 || (e2.__u = e2(r2));
      } else e2.current = r2;
    } catch (e3) {
      t.__e(e3, n2);
    }
  }
  function D(e2, r2, n2) {
    var a2, i2;
    if (t.unmount && t.unmount(e2), (a2 = e2.ref) && (a2.current && a2.current !== e2.__e || E(a2, null, r2)), null != (a2 = e2.__c)) {
      if (a2.componentWillUnmount) try {
        a2.componentWillUnmount();
      } catch (e3) {
        t.__e(e3, r2);
      }
      a2.base = a2.__P = null;
    }
    if (a2 = e2.__k) for (i2 = 0; i2 < a2.length; i2++) a2[i2] && D(a2[i2], r2, n2 || "function" != typeof e2.type);
    n2 || m(e2.__e), e2.__c = e2.__ = e2.__e = void 0;
  }
  function L(e2, t2, r2) {
    return this.constructor(e2, r2);
  }
  function O(r2, n2, a2) {
    var i2, o2, c2;
    n2 == document && (n2 = document.documentElement), t.__ && t.__(r2, n2), i2 = false ? null : n2.__k, o2 = [], c2 = [], q(n2, r2 = n2.__k = function(t2, r3, n3) {
      var a3, i3, o3, c3 = {};
      for (o3 in r3) "key" == o3 ? a3 = r3[o3] : "ref" == o3 ? i3 = r3[o3] : c3[o3] = r3[o3];
      if (arguments.length > 2 && (c3.children = arguments.length > 3 ? e.call(arguments, 2) : n3), "function" == typeof t2 && null != t2.defaultProps) for (o3 in t2.defaultProps) void 0 === c3[o3] && (c3[o3] = t2.defaultProps[o3]);
      return g(t2, c3, a3, i3, null);
    }(h, null, [r2]), i2 || p, p, n2.namespaceURI, i2 ? null : n2.firstChild ? e.call(n2.childNodes) : null, o2, i2 ? i2.__e : n2.firstChild, false, c2), R(o2, r2, c2);
  }
  e = d.slice, t = { __e: function(e2, t2, r2, n2) {
    for (var a2, i2, o2; t2 = t2.__; ) if ((a2 = t2.__c) && !a2.__) try {
      if ((i2 = a2.constructor) && null != i2.getDerivedStateFromError && (a2.setState(i2.getDerivedStateFromError(e2)), o2 = a2.__d), null != a2.componentDidCatch && (a2.componentDidCatch(e2, n2 || {}), o2 = a2.__d), o2) return a2.__E = a2;
    } catch (t3) {
      e2 = t3;
    }
    throw e2;
  } }, r = 0, v.prototype.setState = function(e2, t2) {
    var r2;
    r2 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = f({}, this.state), "function" == typeof e2 && (e2 = e2(f({}, r2), this.props)), e2 && f(r2, e2), null != e2 && this.__v && (t2 && this._sb.push(t2), F(this));
  }, v.prototype.forceUpdate = function(e2) {
    this.__v && (this.__e = true, e2 && this.__h.push(e2), F(this));
  }, v.prototype.render = h, n = [], i = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, o = function(e2, t2) {
    return e2.__v.__b - t2.__v.__b;
  }, $.__r = 0, c = /(PointerCapture)$|Capture$/i, l = 0, s = k(false), u = k(true);
  var j = 0;
  function U(e2, r2, n2, a2, i2, o2) {
    r2 || (r2 = {});
    var c2, l2, s2 = r2;
    if ("ref" in s2) for (l2 in s2 = {}, r2) "ref" == l2 ? c2 = r2[l2] : s2[l2] = r2[l2];
    var u2 = { type: e2, props: s2, key: n2, ref: c2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --j, __i: -1, __u: 0, __source: i2, __self: o2 };
    if ("function" == typeof e2 && (c2 = e2.defaultProps)) for (l2 in c2) void 0 === s2[l2] && (s2[l2] = c2[l2]);
    return t.vnode && t.vnode(u2), u2;
  }
  const H = /* @__PURE__ */ new Map(), M = /* @__PURE__ */ new Map();
  let G = [], W = false, Q = null;
  const B = (e2) => Date.now() - e2 > 3e5, V = async ({ shopDomain: e2, accessToken: t2, query: r2, variables: n2 }) => {
    try {
      const a2 = `https://${e2}/api/2024-07/graphql.json`, i2 = { "X-Shopify-Storefront-Access-Token": t2, "Content-Type": "application/json" }, o2 = await fetch(a2, { method: "POST", headers: i2, body: JSON.stringify({ query: r2, variables: n2 }) });
      return await o2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  }, Y = async (e2, t2, r2, n2, a2, i2) => {
    const o2 = ((e3, t3, r3, n3, a3) => `${e3}:${t3}:${r3}:${JSON.stringify(n3)}:${a3}`)(e2, r2, n2, a2, i2), c2 = H.get(o2);
    if (c2 && !B(c2.timestamp)) return c2.data;
    const l2 = M.get(o2);
    if (l2) return l2;
    const s2 = (u2 = { shopDomain: e2, accessToken: t2, handle: r2, customerGroupId: n2, customerTags: a2, clayCountryIsoCode: i2, cacheKey: o2 }, new Promise((e3, t3) => {
      G.push({ ...u2, resolve: e3, reject: t3 }), W || (W = true, queueMicrotask(() => {
        W = false, function() {
          if (0 === G.length) return;
          const e4 = G;
          G = [];
          for (let t4 = 0; t4 < e4.length; t4 += 10) {
            const r3 = e4.slice(t4, t4 + 10), n3 = null === Q, a3 = J(r3, n3);
            n3 && (Q = a3);
          }
        }();
      }));
    }));
    var u2;
    return M.set(o2, s2), s2.finally(() => {
      M.delete(o2);
    }), s2;
  };
  async function J(e2, t2) {
    var _a, _b, _c;
    if (!t2 && Q) try {
      await Q;
    } catch {
    }
    const r2 = e2[0];
    try {
      const t3 = function(e3) {
        const t4 = e3.map((e4, t5) => `p${t5}: product(handle: ${JSON.stringify(e4)}) {
      title
      handle
      variants(first: 250) {
        edges {
          node {
            id
            title
            metafield(namespace: "app--173437812737--clay", key: "pricing_rule") {
              value
              type
            }
            price { amount currencyCode }
            compareAtPrice { amount currencyCode }
            availableForSale
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }`).join("\n");
        return `query batchProductMetafield($country: CountryCode) @inContext(country: $country) {
    ${t4}
  }`;
      }(e2.map((e3) => e3.handle)), n2 = await V({ shopDomain: r2.shopDomain, accessToken: r2.accessToken, query: t3, variables: { country: r2.clayCountryIsoCode } });
      if (!(n2 == null ? void 0 : n2.data)) {
        const t4 = new Error("Empty response from Storefront API");
        return void e2.forEach((e3) => e3.reject(t4));
      }
      for (let t4 = 0; t4 < e2.length; t4++) {
        const r3 = e2[t4], a2 = n2.data[`p${t4}`];
        if (!a2) {
          const e3 = { handle: r3.handle, allVariants: [] };
          H.set(r3.cacheKey, { data: e3, timestamp: Date.now() }), r3.resolve(e3);
          continue;
        }
        if ((_b = (_a = a2.variants) == null ? void 0 : _a.pageInfo) == null ? void 0 : _b.hasNextPage) {
          z(r3.shopDomain, r3.accessToken, r3.handle, r3.customerGroupId, r3.customerTags, r3.clayCountryIsoCode, r3.cacheKey).then((e3) => r3.resolve(e3)).catch(r3.reject);
          continue;
        }
        const i2 = (((_c = a2.variants) == null ? void 0 : _c.edges) || []).map((e3) => K(e3.node, r3.customerGroupId, r3.customerTags)), o2 = { handle: r3.handle, allVariants: i2 };
        H.set(r3.cacheKey, { data: o2, timestamp: Date.now() }), r3.resolve(o2);
      }
      X();
    } catch (t3) {
      console.error("Error in batched product metafield fetch:", t3), e2.forEach((e3) => e3.reject(t3));
    }
  }
  function K(e2, t2, r2) {
    var _a;
    const n2 = e2.id.split("/").pop(), a2 = (_a = e2.metafield) == null ? void 0 : _a.value, i2 = function(e3) {
      if (!Array.isArray(e3) || 0 === e3.length) return [];
      const t3 = e3[0];
      if ("customerGroupId" in t3) return r3 = e3, Array.isArray(r3) ? r3.map((e4 = {}) => {
        const { customerGroupId: t4 = "", customerTag: r4 = "", type: n3 = "WHOLESALE", wholesalePrice: a3 = null, quantityPrice: i3 = {} } = e4;
        let o3 = false;
        "QUANTITY" === n3 && (o3 = !!i3.isVariantUnique);
        let c3 = [];
        return "WHOLESALE" === n3 && null != a3 ? c3.push({ quantity: "1", price: a3 }) : Array.isArray(i3.value) && (c3 = i3.value), { ownerId: "", customerGroupId: t4, customerTag: r4, markets: [{ handle: "", currency: "", pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: o3, priceSource: "R", values: c3 } }] };
      }) : [];
      var r3;
      if ("i" in t3) return function(e4) {
        if (!e4 || !Array.isArray(e4)) return null;
        const t4 = e4.map((e5 = {}) => {
          let t5 = e5.o || "", [r4 = "", n3 = ""] = (e5.i || "").split("~"), a3 = e5.p.split("|").map((e6) => {
            let [t6 = "", r5 = "", n4 = "A", a4 = "0", i3 = "R", o3 = ""] = e6.split("~"), c3 = o3.split(";").map((e7) => {
              let [t7 = "1", r6 = "0"] = e7.split(":");
              return { quantity: t7, price: r6 };
            }) ?? [];
            return { handle: t6, currency: r5, pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: n4, priceSource: i3, isVariantUnique: "1" === a4, values: c3 } };
          });
          return { ownerId: t5, customerGroupId: r4, customerTag: n3, markets: a3 };
        });
        return t4;
      }(e3);
      return [];
    }("string" == typeof a2 ? JSON.parse(a2) : []);
    let o2 = i2.find((e3) => e3.customerGroupId === t2 && !["LOGGED_IN", "ALL"].includes(t2) || r2.includes(e3.customerTag));
    o2 || "ALL" === t2 || (o2 = i2.find((e3) => "LOGGED_IN" === e3.customerGroupId)), o2 || (o2 = i2.find((e3) => "ALL" === e3.customerGroupId));
    const c2 = window.clayMarketHandle;
    if (o2) {
      const t3 = o2.markets.find((e3) => e3.handle === c2 || "" === e3.handle) || null;
      if (t3) {
        const r3 = { ...o2, markets: [t3] };
        if ("" === r3.ownerId || r3.ownerId === n2.split("/").pop()) return { id: n2, title: e2.title, pricingRule: r3, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
      }
    }
    return { id: n2, title: e2.title, pricingRule: null, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
  }
  async function z(e2, t2, r2, n2, a2, i2, o2) {
    var _a, _b, _c, _d, _e2, _f, _g, _h, _i, _j;
    try {
      let c2, l2 = true;
      const s2 = [];
      for (; l2; ) {
        const u3 = await V({ shopDomain: e2, accessToken: t2, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250, after: ${c2 ? `"${c2}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                    availableForSale
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: r2, country: i2 } });
        if (!((_a = u3.data) == null ? void 0 : _a.product)) {
          const e3 = { handle: r2, allVariants: [] };
          return H.set(o2, { data: e3, timestamp: Date.now() }), e3;
        }
        const p2 = (((_b = u3.data.product.variants) == null ? void 0 : _b.edges) || []).map((e3) => K(e3.node, n2, a2));
        s2.push(...p2), l2 = (_f = (_e2 = (_d = (_c = u3.data) == null ? void 0 : _c.product) == null ? void 0 : _d.variants) == null ? void 0 : _e2.pageInfo) == null ? void 0 : _f.hasNextPage, c2 = (_j = (_i = (_h = (_g = u3.data) == null ? void 0 : _g.product) == null ? void 0 : _h.variants) == null ? void 0 : _i.pageInfo) == null ? void 0 : _j.endCursor;
      }
      const u2 = { handle: r2, allVariants: s2 };
      return H.set(o2, { data: u2, timestamp: Date.now() }), X(), u2;
    } catch (e3) {
      throw console.error("Error fetching product metafield:", e3), e3;
    }
  }
  const X = () => {
    for (const [e2, t2] of H.entries()) B(t2.timestamp) && H.delete(e2);
  };
  function Z(e2, t2) {
    if (null === e2) return "";
    const r2 = "string" == typeof e2 ? parseFloat(e2) : e2, n2 = r2.toFixed(2), a2 = r2.toFixed(0), i2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), o2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), c2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), l2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), s2 = n2.replace(".", ","), u2 = i2.replace(/(\d+)\.(\d{2})$/, "$1,$2"), p2 = c2.replace(/(\d+)\.(\d{2})$/, "$1,$2");
    return t2.replace("{{amount}}", n2).replace("{{amount_no_decimals}}", a2).replace("{{amount_with_comma_separator}}", i2).replace("{{amount_no_decimals_with_comma_separator}}", o2).replace("{{amount_with_period_separator}}", c2).replace("{{amount_no_decimals_with_period_separator}}", l2).replace("{{amount_with_comma_decimal}}", s2).replace("{{amount_with_comma_separator_and_comma_decimal}}", u2).replace("{{amount_with_period_separator_and_comma_decimal}}", p2);
  }
  function ee(e2, t2, r2) {
    var _a;
    let n2 = "", a2 = "", i2 = "", o2 = "", c2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!c2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
    let l2 = c2.pricing.type;
    return "QUANTITY" === l2 ? { retailPriceText: n2, compareAtPriceText: a2, savingsText: i2, maxRetailPriceText: o2 } = function(e3, t3, r3, n3) {
      let a3 = n3.pricing.strategy, i3 = n3.pricing.values, o3 = n3.currency, c3 = e3.price.currencyCode, l3 = "R" === n3.pricing.priceSource ? e3.price.amount : "C" === n3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, s2 = window.marketConversionRate;
      if (!l3 || "" === l3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      let u2 = i3.filter((e4) => Number(e4.quantity) <= r3).reduce((e4, t4) => Number(t4.quantity) > Number(e4.quantity) ? t4 : e4, { price: "0", quantity: "0" }).price;
      if (o3 !== c3 && "" !== o3) {
        if (!s2 || !s2.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(a3) && (u2 = (parseFloat(u2) * s2.conversion_rate).toFixed(2).toString());
      }
      let p2 = "A" === a3 ? u2 : "P" === a3 ? (parseFloat(l3) * (1 - parseFloat(u2) / 100)).toFixed(2).toString() : "F" === a3 ? (parseFloat(l3) - parseFloat(u2)).toFixed(2).toString() : e3.price.amount;
      if (("A" === a3 || "F" === a3) && "" === o3 && s2 && s2.base_currency !== c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(p2) < 0 || parseFloat(p2) > parseFloat(e3.price.amount)) && (p2 = e3.price.amount);
      let d2 = Z(p2, clayProductPriceConfig.priceDisplayText), y2 = Z(l3, clayProductPriceConfig.compareAtPriceDisplayText), _2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(l3) - parseFloat(p2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(l3) - parseFloat(p2)) / parseFloat(l3) * 100).toFixed(2) : 0, f2 = Z(_2, clayProductPriceConfig.savingsDisplayText);
      return s2 && (d2 = window.clayCurrencySymbol + parseFloat(p2).toFixed(2) + " " + window.clayCountryCurrency, y2 = window.clayCurrencySymbol + parseFloat(l3).toFixed(2) + " " + window.clayCountryCurrency, f2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + _2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? _2 + "%" : "")), parseFloat(_2) > 0 || (f2 = ""), { retailPriceText: d2, compareAtPriceText: y2, savingsText: f2, maxRetailPriceText: "" };
    }(e2, 0, r2, c2) : "WHOLESALE" === l2 && ({ retailPriceText: n2, compareAtPriceText: a2, savingsText: i2, maxRetailPriceText: o2 } = function(e3, t3, r3) {
      let n3 = r3.pricing.strategy;
      r3.pricing.values;
      let a3 = r3.currency, i3 = e3.price.currencyCode, o3 = window.marketConversionRate, c3 = "R" === r3.pricing.priceSource ? e3.price.amount : "C" === r3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, l3 = r3.pricing.values[0].price;
      if (!c3 || "" === c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      if (a3 !== i3 && "" !== a3) {
        if (!o3 || !o3.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(n3) && (l3 = (parseFloat(l3) * o3.conversion_rate).toFixed(2).toString());
      }
      let s2 = "A" === n3 ? l3 : "P" === n3 ? (parseFloat(c3) * (1 - parseFloat(l3) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(c3) - parseFloat(l3)).toFixed(2).toString() : e3.price.amount;
      if (("A" === n3 || "F" === n3) && "" === a3 && o3 && o3.base_currency !== i3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(s2) < 0 || parseFloat(s2) > parseFloat(e3.price.amount)) && (s2 = e3.price.amount);
      let u2 = Z(s2, clayProductPriceConfig.priceDisplayText), p2 = Z(c3, clayProductPriceConfig.compareAtPriceDisplayText), d2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c3) - parseFloat(s2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c3) - parseFloat(s2)) / parseFloat(c3) * 100).toFixed(2) : 0, y2 = Z(d2, clayProductPriceConfig.savingsDisplayText);
      return o3 && (u2 = window.clayCurrencySymbol + parseFloat(s2).toFixed(2) + " " + window.clayCountryCurrency, p2 = window.clayCurrencySymbol + parseFloat(c3).toFixed(2) + " " + window.clayCountryCurrency, y2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + d2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? d2 + "%" : "")), parseFloat(d2) > 0 || (y2 = ""), { retailPriceText: u2, compareAtPriceText: p2, savingsText: y2, maxRetailPriceText: "" };
    }(e2, 0, c2)), { retailPriceText: n2, compareAtPriceText: a2, savingsText: i2, maxRetailPriceText: o2 };
  }
  function te(e2, t2) {
    var _a;
    let r2 = "", n2 = "", a2 = "", i2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!i2) return { retailPrice: "", compareAtPrice: "", savings: "" };
    let o2 = i2.pricing.type;
    return "QUANTITY" === o2 ? { retailPrice: r2, compareAtPrice: n2, savings: a2 } = function(e3, t3, r3) {
      let n3 = r3.pricing.strategy, a3 = r3.pricing.values, i3 = r3.currency, o3 = e3.price.currencyCode, c2 = "R" === r3.pricing.priceSource ? e3.price.amount : "C" === r3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, l2 = window.marketConversionRate;
      if (!c2 || "" === c2) return { retailPrice: "", compareAtPrice: "", savings: "" };
      let s2 = a3.filter((e4) => Number(e4.quantity) <= t3).reduce((e4, t4) => Number(t4.quantity) > Number(e4.quantity) ? t4 : e4, { price: "0", quantity: "0" }).price;
      if (i3 !== o3 && "" !== i3) {
        if (!l2 || !l2.conversion_rate) return { retailPrice: "", compareAtPrice: "", savings: "" };
        ["A", "F"].includes(n3) && (s2 = (parseFloat(s2) * l2.conversion_rate).toFixed(2).toString());
      }
      let u2 = "A" === n3 ? s2 : "P" === n3 ? (parseFloat(c2) * (1 - parseFloat(s2) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(c2) - parseFloat(s2)).toFixed(2).toString() : e3.price.amount;
      if (("A" === n3 || "F" === n3) && "" === i3 && l2 && l2.base_currency !== o3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      (parseFloat(u2) < 0 || parseFloat(u2) > parseFloat(e3.price.amount)) && (u2 = e3.price.amount);
      let p2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c2) - parseFloat(u2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c2) - parseFloat(u2)) / parseFloat(c2) * 100).toFixed(0) : 0;
      return { retailPrice: u2, compareAtPrice: parseFloat(c2).toFixed(2), savings: p2 };
    }(e2, t2, i2) : "WHOLESALE" === o2 && ({ retailPrice: r2, compareAtPrice: n2, savings: a2 } = function(e3, t3) {
      let r3 = t3.pricing.strategy;
      t3.pricing.values;
      let n3 = t3.currency, a3 = e3.price.currencyCode, i3 = window.marketConversionRate, o3 = "R" === t3.pricing.priceSource ? e3.price.amount : "C" === t3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, c2 = t3.pricing.values[0].price;
      if (!o3 || "" === o3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      if (n3 !== a3 && "" !== n3) {
        if (!i3 || !i3.conversion_rate) return { retailPrice: "", compareAtPrice: "", savings: "" };
        ["A", "F"].includes(r3) && (c2 = (parseFloat(c2) * i3.conversion_rate).toFixed(2).toString());
      }
      let l2 = "A" === r3 ? c2 : "P" === r3 ? (parseFloat(o3) * (1 - parseFloat(c2) / 100)).toFixed(2).toString() : "F" === r3 ? (parseFloat(o3) - parseFloat(c2)).toFixed(2).toString() : e3.price.amount;
      if (("A" === r3 || "F" === r3) && "" === n3 && i3 && i3.base_currency !== a3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      (parseFloat(l2) < 0 || parseFloat(l2) > parseFloat(e3.price.amount)) && (l2 = e3.price.amount);
      let s2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(o3) - parseFloat(l2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(o3) - parseFloat(l2)) / parseFloat(o3) * 100).toFixed(2) : 0;
      return { retailPrice: l2, compareAtPrice: parseFloat(o3).toFixed(2), savings: s2 };
    }(e2, i2)), { retailPrice: r2, compareAtPrice: n2, savings: a2 };
  }
  function re(e2, t2, r2, n2, a2) {
    return e2.replace("{retailPriceText}", t2).replace("{compareAtPriceText}", r2).replace("{savingsText}", n2).replace("{maxRetailPriceText}", a2);
  }
  function ne(e2) {
    if (!e2 || "" === e2) return null;
    let t2 = null;
    const r2 = e2.match(/\/products\/([^/?#]+)/);
    return r2 && r2[1] && (t2 = decodeURIComponent(r2[1])), t2;
  }
  async function ae(e2) {
    const t2 = window.clayStorefrontConfig || {}, r2 = window.clayCustomerTier || {}, n2 = window.clayCustomerTags || [], a2 = window.clayCountryIsoCode, { allVariants: i2 } = await Y(t2.shopDomain, t2.token, e2, "" === r2.customerGroupId ? "LOGGED_IN" : r2.customerGroupId, n2, a2);
    return i2;
  }
  const ie = "%[a-f0-9]{2}", oe = new RegExp("(" + ie + ")|([^%]+?)", "gi"), ce = new RegExp("(" + ie + ")+", "gi");
  function le(e2, t2) {
    try {
      return [decodeURIComponent(e2.join(""))];
    } catch {
    }
    if (1 === e2.length) return e2;
    t2 = t2 || 1;
    const r2 = e2.slice(0, t2), n2 = e2.slice(t2);
    return Array.prototype.concat.call([], le(r2), le(n2));
  }
  function se(e2) {
    try {
      return decodeURIComponent(e2);
    } catch {
      let t2 = e2.match(oe) || [];
      for (let r2 = 1; r2 < t2.length; r2++) t2 = (e2 = le(t2, r2).join("")).match(oe) || [];
      return e2;
    }
  }
  function ue(e2) {
    if ("string" != typeof e2) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e2 + "`");
    try {
      return decodeURIComponent(e2);
    } catch {
      return function(e3) {
        const t2 = { "%FE%FF": "��", "%FF%FE": "��" };
        let r2 = ce.exec(e3);
        for (; r2; ) {
          try {
            t2[r2[0]] = decodeURIComponent(r2[0]);
          } catch {
            const e4 = se(r2[0]);
            e4 !== r2[0] && (t2[r2[0]] = e4);
          }
          r2 = ce.exec(e3);
        }
        t2["%C2"] = "�";
        const n2 = Object.keys(t2);
        for (const r3 of n2) e3 = e3.replace(new RegExp(r3, "g"), t2[r3]);
        return e3;
      }(e2);
    }
  }
  function pe(e2, t2) {
    const r2 = {};
    if (Array.isArray(t2)) for (const n2 of t2) {
      const t3 = Object.getOwnPropertyDescriptor(e2, n2);
      (t3 == null ? void 0 : t3.enumerable) && Object.defineProperty(r2, n2, t3);
    }
    else for (const n2 of Reflect.ownKeys(e2)) {
      const a2 = Object.getOwnPropertyDescriptor(e2, n2);
      if (a2.enumerable) {
        t2(n2, e2[n2], e2) && Object.defineProperty(r2, n2, a2);
      }
    }
    return r2;
  }
  function de(e2, t2) {
    if ("string" != typeof e2 || "string" != typeof t2) throw new TypeError("Expected the arguments to be of type `string`");
    if ("" === e2 || "" === t2) return [];
    const r2 = e2.indexOf(t2);
    return -1 === r2 ? [] : [e2.slice(0, r2), e2.slice(r2 + t2.length)];
  }
  const ye = Symbol("encodeFragmentIdentifier");
  function _e(e2) {
    if ("string" != typeof e2 || 1 !== e2.length) throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function fe(e2, t2) {
    return t2.encode ? t2.strict ? encodeURIComponent(e2).replaceAll(/[!'()*]/g, (e3) => `%${e3.charCodeAt(0).toString(16).toUpperCase()}`) : encodeURIComponent(e2) : e2;
  }
  function me(e2, t2) {
    return t2.decode ? ue(e2) : e2;
  }
  function ge(e2) {
    return Array.isArray(e2) ? e2.sort() : "object" == typeof e2 ? ge(Object.keys(e2)).sort((e3, t2) => Number(e3) - Number(t2)).map((t2) => e2[t2]) : e2;
  }
  function he(e2) {
    const t2 = e2.indexOf("#");
    return -1 !== t2 && (e2 = e2.slice(0, t2)), e2;
  }
  function ve(e2, t2, r2) {
    return "string" === r2 && "string" == typeof e2 ? e2 : "function" == typeof r2 && "string" == typeof e2 ? r2(e2) : !t2.parseBooleans || null === e2 || "true" !== e2.toLowerCase() && "false" !== e2.toLowerCase() ? "number" !== r2 || Number.isNaN(Number(e2)) || "string" != typeof e2 || "" === e2.trim() ? t2.parseNumbers && !Number.isNaN(Number(e2)) && "string" == typeof e2 && "" !== e2.trim() ? Number(e2) : e2 : Number(e2) : "true" === e2.toLowerCase();
  }
  function xe(e2) {
    const t2 = (e2 = he(e2)).indexOf("?");
    return -1 === t2 ? "" : e2.slice(t2 + 1);
  }
  function Pe(e2, t2) {
    _e((t2 = { decode: true, sort: true, arrayFormat: "none", arrayFormatSeparator: ",", parseNumbers: false, parseBooleans: false, types: /* @__PURE__ */ Object.create(null), ...t2 }).arrayFormatSeparator);
    const r2 = function(e3) {
      let t3;
      switch (e3.arrayFormat) {
        case "index":
          return (e4, r3, n3) => {
            t3 = /\[(\d*)]$/.exec(e4), e4 = e4.replace(/\[\d*]$/, ""), t3 ? (void 0 === n3[e4] && (n3[e4] = {}), n3[e4][t3[1]] = r3) : n3[e4] = r3;
          };
        case "bracket":
          return (e4, r3, n3) => {
            t3 = /(\[])$/.exec(e4), e4 = e4.replace(/\[]$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "colon-list-separator":
          return (e4, r3, n3) => {
            t3 = /(:list)$/.exec(e4), e4 = e4.replace(/:list$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "comma":
        case "separator":
          return (t4, r3, n3) => {
            const a2 = "string" == typeof r3 && r3.includes(e3.arrayFormatSeparator), i2 = "string" == typeof r3 && !a2 && me(r3, e3).includes(e3.arrayFormatSeparator);
            r3 = i2 ? me(r3, e3) : r3;
            const o2 = a2 || i2 ? r3.split(e3.arrayFormatSeparator).map((t5) => me(t5, e3)) : null === r3 ? r3 : me(r3, e3);
            n3[t4] = o2;
          };
        case "bracket-separator":
          return (t4, r3, n3) => {
            const a2 = /(\[])$/.test(t4);
            if (t4 = t4.replace(/\[]$/, ""), !a2) return void (n3[t4] = r3 ? me(r3, e3) : r3);
            const i2 = null === r3 ? [] : me(r3, e3).split(e3.arrayFormatSeparator);
            void 0 !== n3[t4] ? n3[t4] = [...n3[t4], ...i2] : n3[t4] = i2;
          };
        default:
          return (e4, t4, r3) => {
            void 0 !== r3[e4] ? r3[e4] = [...[r3[e4]].flat(), t4] : r3[e4] = t4;
          };
      }
    }(t2), n2 = /* @__PURE__ */ Object.create(null);
    if ("string" != typeof e2) return n2;
    if (!(e2 = e2.trim().replace(/^[?#&]/, ""))) return n2;
    for (const a2 of e2.split("&")) {
      if ("" === a2) continue;
      const e3 = t2.decode ? a2.replaceAll("+", " ") : a2;
      let [i2, o2] = de(e3, "=");
      void 0 === i2 && (i2 = e3), o2 = void 0 === o2 ? null : ["comma", "separator", "bracket-separator"].includes(t2.arrayFormat) ? o2 : me(o2, t2), r2(me(i2, t2), o2, n2);
    }
    for (const [e3, r3] of Object.entries(n2)) if ("object" == typeof r3 && null !== r3 && "string" !== t2.types[e3]) for (const [n3, a2] of Object.entries(r3)) {
      const i2 = t2.types[e3] ? t2.types[e3].replace("[]", "") : void 0;
      r3[n3] = ve(a2, t2, i2);
    }
    else "object" == typeof r3 && null !== r3 && "string" === t2.types[e3] ? n2[e3] = Object.values(r3).join(t2.arrayFormatSeparator) : n2[e3] = ve(r3, t2, t2.types[e3]);
    return false === t2.sort ? n2 : (true === t2.sort ? Object.keys(n2).sort() : Object.keys(n2).sort(t2.sort)).reduce((e3, t3) => {
      const r3 = n2[t3];
      return e3[t3] = Boolean(r3) && "object" == typeof r3 && !Array.isArray(r3) ? ge(r3) : r3, e3;
    }, /* @__PURE__ */ Object.create(null));
  }
  function Fe(e2, t2) {
    if (!e2) return "";
    _e((t2 = { encode: true, strict: true, arrayFormat: "none", arrayFormatSeparator: ",", ...t2 }).arrayFormatSeparator);
    const r2 = (r3) => t2.skipNull && null == e2[r3] || t2.skipEmptyString && "" === e2[r3], n2 = function(e3) {
      switch (e3.arrayFormat) {
        case "index":
          return (t3) => (r3, n3) => {
            const a3 = r3.length;
            return void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [fe(t3, e3), "[", a3, "]"].join("")] : [...r3, [fe(t3, e3), "[", fe(a3, e3), "]=", fe(n3, e3)].join("")];
          };
        case "bracket":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [fe(t3, e3), "[]"].join("")] : [...r3, [fe(t3, e3), "[]=", fe(n3, e3)].join("")];
        case "colon-list-separator":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [fe(t3, e3), ":list="].join("")] : [...r3, [fe(t3, e3), ":list=", fe(n3, e3)].join("")];
        case "comma":
        case "separator":
        case "bracket-separator": {
          const t3 = "bracket-separator" === e3.arrayFormat ? "[]=" : "=";
          return (r3) => (n3, a3) => void 0 === a3 || e3.skipNull && null === a3 || e3.skipEmptyString && "" === a3 ? n3 : (a3 = null === a3 ? "" : a3, 0 === n3.length ? [[fe(r3, e3), t3, fe(a3, e3)].join("")] : [[n3, fe(a3, e3)].join(e3.arrayFormatSeparator)]);
        }
        default:
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, fe(t3, e3)] : [...r3, [fe(t3, e3), "=", fe(n3, e3)].join("")];
      }
    }(t2), a2 = {};
    for (const [t3, n3] of Object.entries(e2)) r2(t3) || (a2[t3] = n3);
    const i2 = Object.keys(a2);
    return false !== t2.sort && i2.sort(t2.sort), i2.map((r3) => {
      const a3 = e2[r3];
      return void 0 === a3 ? "" : null === a3 ? fe(r3, t2) : Array.isArray(a3) ? 0 === a3.length && "bracket-separator" === t2.arrayFormat ? fe(r3, t2) + "[]" : a3.reduce(n2(r3), []).join("&") : fe(r3, t2) + "=" + fe(a3, t2);
    }).filter((e3) => e3.length > 0).join("&");
  }
  function be(e2, t2) {
    var _a;
    t2 = { decode: true, ...t2 };
    let [r2, n2] = de(e2, "#");
    return void 0 === r2 && (r2 = e2), { url: ((_a = r2 == null ? void 0 : r2.split("?")) == null ? void 0 : _a[0]) ?? "", query: Pe(xe(e2), t2), ...t2 && t2.parseFragmentIdentifier && n2 ? { fragmentIdentifier: me(n2, t2) } : {} };
  }
  function Te(e2, t2) {
    t2 = { encode: true, strict: true, [ye]: true, ...t2 };
    const r2 = he(e2.url).split("?")[0] || "";
    let n2 = Fe({ ...Pe(xe(e2.url), { sort: false }), ...e2.query }, t2);
    n2 && (n2 = `?${n2}`);
    let a2 = function(e3) {
      let t3 = "";
      const r3 = e3.indexOf("#");
      return -1 !== r3 && (t3 = e3.slice(r3)), t3;
    }(e2.url);
    if ("string" == typeof e2.fragmentIdentifier) {
      const n3 = new URL(r2);
      n3.hash = e2.fragmentIdentifier, a2 = t2[ye] ? n3.hash : `#${e2.fragmentIdentifier}`;
    }
    return `${r2}${n2}${a2}`;
  }
  function we(e2, t2, r2) {
    r2 = { parseFragmentIdentifier: true, [ye]: false, ...r2 };
    const { url: n2, query: a2, fragmentIdentifier: i2 } = be(e2, r2);
    return Te({ url: n2, query: pe(a2, t2), fragmentIdentifier: i2 }, r2);
  }
  const Se = Object.freeze(Object.defineProperty({ __proto__: null, exclude: function(e2, t2, r2) {
    return we(e2, Array.isArray(t2) ? (e3) => !t2.includes(e3) : (e3, r3) => !t2(e3, r3), r2);
  }, extract: xe, parse: Pe, parseUrl: be, pick: we, stringify: Fe, stringifyUrl: Te }, Symbol.toStringTag, { value: "Module" })), Ce = window.clayStorefrontConfig || {}, Ae = window.clayCustomerTags || [], ke = window.clayProductPriceConfig || {}, qe = window.clayMarketHandle, Re = window.clayCountryCurrency, Ne = window.clayCountryIsoCode, Ie = ".product-card", Ee = 'a[href*="/products/"]', De = ".product-card-content .product-price", Le = ".main-product .product-price-wrapper .product-price", Oe = "display:flex;flex-wrap:wrap;align-items:center;gap:0.8rem;", je = '<span class="regular-price">{retailPriceText}</span>', $e = '<span class="price">{retailPriceText}</span><s class="regular-price">{compareAtPriceText}</s>', Ue = '.main-product [data-type="add-to-cart-form"] .quantity-input';
  let He = null;
  async function Me() {
    const e2 = ne(window.location.href);
    if (e2) {
      const t2 = await ae(e2);
      if (t2 && t2.length > 0) {
        const e3 = new URL(window.location.href);
        let r2 = Se.parse(e3.search).variant;
        if (!r2) {
          const e4 = t2.find((e5) => e5.availableForSale);
          r2 = (e4 || t2[0]).id;
        }
        const n2 = t2.find((e4) => e4.id === r2);
        n2 && async function(e4, t3) {
          var _a;
          const r3 = document.querySelectorAll(Le), n3 = (_a = r3[0]) == null ? void 0 : _a.parentElement;
          if (n3 == null ? void 0 : n3.__clayObserver) setTimeout(() => {
            Qe(e4, t3);
          }, 100);
          else {
            const r4 = new MutationObserver(() => {
              setTimeout(() => {
                Qe(e4, t3);
              }, 100);
            }), a2 = { attributes: true, childList: true, subtree: true, characterData: true };
            n3 && (r4.observe(n3, a2), n3.__clayObserver = r4, setTimeout(() => {
              Qe(e4, t3);
            }, 100), setTimeout(() => {
              Qe(e4, t3);
            }, 500));
          }
        }(n2, t2);
      }
    }
    Be(0, 1e4);
  }
  function Ge(e2) {
    var _a;
    const t2 = (_a = e2.pricingRule) == null ? void 0 : _a.markets[0];
    if (!t2 || "QUANTITY" !== t2.pricing.type) return 1;
    const r2 = t2.pricing.values.map((e3) => Number(e3.quantity)).filter((e3) => e3 > 1).sort((e3, t3) => e3 - t3);
    return r2.length > 0 ? r2[0] : 1;
  }
  function We() {
    var _a, _b, _c;
    if (!He) return;
    const { variant: e2, allVariants: t2 } = He, r2 = document.querySelector(".main-product .add-to-cart-button");
    if (!r2) return;
    const n2 = function(e3, t3) {
      var _a2;
      const r3 = (_a2 = e3.pricingRule) == null ? void 0 : _a2.markets[0];
      if (!r3 || "QUANTITY" !== r3.pricing.type) return t3;
      const n3 = Math.min(...r3.pricing.values.map((e4) => Number(e4.quantity)));
      return t3 < n3 ? n3 : t3;
    }(e2, function() {
      const e3 = document.querySelector(Ue), t3 = e3 ? parseInt(e3.value, 10) : 1;
      return Number.isFinite(t3) && t3 > 0 ? t3 : 1;
    }()), { retailPriceText: a2 } = ee(e2, 0, n2);
    if (!a2) return;
    const i2 = '<span class="regular-price clay-atc-price"><span class="sr-only">Price: </span>' + a2 + "</span>", o2 = r2.querySelector(".product-price"), c2 = r2.querySelector(":scope > .regular-price");
    if ((_a = r2.querySelector(":scope > .price")) == null ? void 0 : _a.remove(), (_b = r2.querySelector(":scope > .product-sale-label")) == null ? void 0 : _b.remove(), (_c = r2.querySelector(":scope > .unit-price")) == null ? void 0 : _c.remove(), o2) c2 && c2.remove(), o2.outerHTML = i2;
    else {
      if (!c2) return;
      c2.outerHTML !== i2 && (c2.outerHTML = i2);
    }
    if (!r2.__clayObserver) {
      const e3 = new MutationObserver(() => {
        r2.querySelector(".clay-atc-price") || setTimeout(We, 0);
      });
      e3.observe(r2, { childList: true }), r2.__clayObserver = e3;
    }
  }
  async function Qe(e2, t2) {
    var _a;
    const r2 = new URL(window.location.href);
    let n2 = Se.parse(r2.search).variant;
    if (!n2) {
      const e3 = t2.find((e4) => e4.availableForSale);
      n2 = (e3 || t2[0]).id;
    }
    const a2 = t2.find((e3) => e3.id === n2), i2 = document.querySelectorAll(Le)[0];
    if (!i2 || !a2) return;
    if (i2.getAttribute("data-variant-id") !== a2.id && i2.setAttribute("data-variant-id", ""), He = { variant: a2, allVariants: t2 }, !a2.pricingRule) return;
    const { retailPriceText: o2, compareAtPriceText: c2, savingsText: l2, maxRetailPriceText: s2 } = ee(a2, 0, 1);
    if ("" === o2) return;
    const u2 = o2 !== c2 && $e ? $e : je;
    let p2 = re(u2, o2, c2, l2, s2);
    if (i2.innerHTML === p2 && i2.classList.contains("clay-wholesale-price") && i2.getAttribute("data-variant-id") === a2.id || (i2.innerHTML = p2, i2.classList.add("clay-wholesale-price"), i2.setAttribute("data-variant-id", a2.id), i2.setAttribute("style", Oe)), !u2.includes("{savingsText}") && o2 !== c2) {
      let e3 = i2.querySelector(".clay-savings-text-container");
      e3 && e3.getAttribute("data-variant-id") === a2.id || (e3 = document.createElement("div"), e3.style = "display: block;", e3.className = "clay-savings-text-container", e3.innerHTML = l2, e3.setAttribute("data-variant-id", a2.id), i2.appendChild(e3));
    }
    if ("none" !== ke.taxDisplayType) {
      let { retailPrice: e3 } = te(a2, 1), t3 = function(e4, t4, r3, n3) {
        if (!t4 || 0 === t4.length) return "";
        const a3 = t4.find((t5) => t5.isoCode === e4);
        if (!a3) return "";
        let i3 = a3.isWholesalePriceInclusiveOfTax, o3 = i3 ? parseFloat(r3) / (1 + 0.01 * parseFloat(a3.taxRate)) : parseFloat(r3), c3 = i3 ? parseFloat(r3) : parseFloat(r3) * (1 + 0.01 * parseFloat(a3.taxRate)), l3 = Z(o3, a3.exclusiveOfTaxText), s3 = Z(c3, a3.inclusiveOfTaxText);
        return "both" === n3 ? `${s3} | ${l3}` : "inclusive" === n3 ? s3 : "exclusive" === n3 ? l3 : "";
      }(Ne, ke.taxRates, e3, ke.taxDisplayType);
      if (t3 && "" !== t3) {
        let e4 = i2.querySelector(".clay-tax-price-container");
        e4 || (e4 = document.createElement("div"), e4.style = "display: block;", e4.className = "clay-tax-price-container", e4.innerHTML = t3, i2.appendChild(e4));
      }
    }
    if ("QUANTITY" === a2.pricingRule.markets[0].pricing.type && ke.showQuantityGrid) {
      const e3 = Ve(a2, ke.quantityGridTemplate, ke.showQuantity1Price);
      if (e3) {
        ((_a = e3[0]) == null ? void 0 : _a.price) && e3.forEach((e4) => {
          let t4 = Z(e4.price, ke.quantityGridPriceDisplayText);
          window.marketConversionRate && (t4 = Z(e4.price, window.clayCurrencySymbol + "{{amount}}")), e4.price = t4;
        });
        let t3 = i2.querySelector(".clay-quantity-grid-table-container");
        t3 && t3.getAttribute("data-variant-id") !== a2.id && (t3.remove(), t3 = null), t3 || (t3 = document.createElement("div"), t3.className = "clay-quantity-grid-table-container", i2.appendChild(t3), O(Ye(e3), t3), t3.setAttribute("data-variant-id", a2.id));
      }
    }
    !function() {
      if (!He) return;
      const { variant: e3, allVariants: t3 } = He, r3 = document.querySelector(Ue);
      if (!r3 || "true" === r3.dataset.claySeeded) return;
      const n3 = Ge(e3);
      if (n3 <= 1) return;
      const { retailPriceText: a3 } = ee(e3, 0, n3);
      if (!a3) return;
      const i3 = parseInt(r3.max, 10);
      Number.isFinite(i3) && i3 > 0 && n3 > i3 || (r3.dataset.claySeeded = "true", r3.value = n3, r3.dispatchEvent(new Event("change", { bubbles: true })));
    }(), We();
  }
  function Be(e2, t2) {
    let r2 = document.querySelectorAll(Ie);
    r2 = Array.from(r2).filter((e3) => {
      const t3 = e3.querySelector(De);
      return t3 && !t3.classList.contains("clay-wholesale-price");
    }), r2 && r2.length > 0 && function(e3) {
      e3.forEach(async (e4) => {
        var _a;
        const t3 = (_a = e4.querySelector(Ee)) == null ? void 0 : _a.href;
        if (!t3) return;
        const r3 = ne(t3), n2 = e4.querySelector(De);
        if (!n2 || n2.classList.contains("clay-wholesale-price")) return;
        const a2 = await ae(r3);
        a2 && 0 !== a2.length && async function(e5, t4) {
          e5.sort((e6, t5) => parseFloat(e6.price.amount) - parseFloat(t5.price.amount));
          const r4 = e5[0];
          if (!r4.pricingRule) return;
          const n3 = t4.querySelector(De), a3 = Ge(r4), { retailPriceText: i2, compareAtPriceText: o2, savingsText: c2, maxRetailPriceText: l2 } = ee(r4, 0, a3);
          if ("" === i2) return;
          const s2 = re(a3 > 1 ? je : i2 !== o2 && $e ? $e : je, i2, o2, c2, l2);
          n3.classList.contains("clay-wholesale-price") || (n3.innerHTML = s2, n3.classList.add("clay-wholesale-price"));
        }(a2, e4);
      });
    }(r2), e2 < t2 && setTimeout(() => {
      Be(e2 + 200, t2);
    }, 200);
  }
  !async function() {
    await async function() {
      fetch("/cart.js").then((e3) => e3.json()).then((e3) => {
        const t3 = { ...e3.attributes, customer_tags: (Ae == null ? void 0 : Ae.join(",")) || "" };
        return fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: t3 }) });
      }).then((e3) => e3.json()).catch((e3) => console.error("Error updating cart:", e3));
      let e2 = null;
      const t2 = await (async (e3, t3, r2) => {
        var _a, _b, _c, _d, _e2, _f, _g, _h;
        let n2 = null, a2 = null, i2 = null, o2 = null;
        try {
          const c2 = await V({ shopDomain: e3, accessToken: t3, query: "query HighPricedProducts($country: CountryCode) @inContext(country: $country) {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }", variables: { country: r2 } });
          ((_c = (_b = (_a = c2 == null ? void 0 : c2.data) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) == null ? void 0 : _c.length) > 0 && (n2 = (_d = c2.data.products.edges[0].node.variants) == null ? void 0 : _d.edges[0].node.price);
          const l2 = await V({ shopDomain: e3, accessToken: t3, query: "query HighPricedProducts {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }" });
          if (((_g = (_f = (_e2 = l2 == null ? void 0 : l2.data) == null ? void 0 : _e2.products) == null ? void 0 : _f.edges) == null ? void 0 : _g.length) > 0 && (a2 = (_h = l2.data.products.edges[0].node.variants) == null ? void 0 : _h.edges[0].node.price), n2 && a2) {
            const e4 = a2.currencyCode;
            e4 !== n2.currencyCode && (o2 = (parseFloat(n2.amount) / parseFloat(a2.amount)).toFixed(8), i2 = e4);
          }
          return { conversionRate: o2, baseCurrency: i2 };
        } catch (e4) {
          return console.error("Error fetching conversion rate:", e4), { conversionRate: null, baseCurrency: null };
        }
      })(Ce.shopDomain, Ce.token, Ne);
      t2.conversionRate && (e2 = { conversion_rate: t2.conversionRate, base_currency: t2.baseCurrency, market_handle: qe, market_currency: Re });
      window.marketConversionRate = e2, e2 && fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { market_conversion_rate: JSON.stringify(e2) } }) }).then((e3) => e3.json()).catch((e3) => console.error("Error updating cart:", e3));
    }(), function() {
      const e2 = (e3) => {
        var _a, _b;
        e3.target && ((_b = (_a = e3.target).matches) == null ? void 0 : _b.call(_a, Ue)) && We();
      };
      document.addEventListener("change", e2), document.addEventListener("input", e2), document.addEventListener("product-variant-updated", () => {
        setTimeout(We, 0);
      });
    }(), function() {
      window.addEventListener("popstate", Me);
      const e2 = history.pushState;
      history.pushState = function() {
        e2.apply(this, arguments), Me();
      };
      const t2 = history.replaceState;
      history.replaceState = function() {
        t2.apply(this, arguments), Me();
      }, Me();
    }(), new MutationObserver((e2) => {
      var _a, _b;
      for (const t2 of e2) for (const e3 of t2.addedNodes) if (1 === e3.nodeType && (((_a = e3.matches) == null ? void 0 : _a.call(e3, Ie)) || ((_b = e3.querySelector) == null ? void 0 : _b.call(e3, Ie)))) return void Be(0, 0);
    }).observe(document.body, { childList: true, subtree: true });
  }();
  const Ve = (e2, t2, r2) => {
    let n2 = e2.pricingRule.markets[0], a2 = n2.pricing.strategy, i2 = n2.pricing.values.map((e3) => ({ ...e3 })), o2 = n2.currency, c2 = e2.price.currencyCode, l2 = "R" === n2.pricing.priceSource ? e2.price.amount : e2.compareAtPrice.amount, s2 = window.marketConversionRate;
    if (("A" === a2 || "F" === a2) && "" === o2 && s2 && s2.base_currency !== c2) return null;
    if (!l2 || "" === l2) return null;
    switch (o2 !== c2 && "" !== o2 && s2 && s2.conversion_rate && ["A", "F"].includes(a2) && i2.forEach((e3) => {
      e3.price = (parseFloat(e3.price) * s2.conversion_rate).toFixed(2).toString();
    }), i2.forEach((t3) => {
      let r3 = "A" === a2 ? t3.price : "P" === a2 ? (parseFloat(l2) * (1 - parseFloat(t3.price) / 100)).toFixed(2).toString() : "F" === a2 ? (parseFloat(l2) - parseFloat(t3.price)).toFixed(2).toString() : e2.price.amount;
      (parseFloat(r3) < 0 || parseFloat(r3) > parseFloat(e2.price.amount)) && (r3 = e2.price.amount), t3.price = r3;
    }), r2 || (i2 = i2.filter((t3) => !("1" === t3.quantity && parseFloat(t3.price) === parseFloat(e2.price.amount)))), t2) {
      case "quantityPrice":
        return i2.map((e3) => ({ quantity: e3.quantity, price: parseFloat(e3.price).toFixed(2) }));
      case "quantityRangePrice":
        return i2.map((e3, t3, r3) => t3 === r3.length - 1 ? { range: `${e3.quantity}+`, price: parseFloat(e3.price).toFixed(2) } : { range: `${e3.quantity}-${r3[t3 + 1].quantity - 1}`, price: parseFloat(e3.price).toFixed(2) });
      case "quantityRangeDiscount":
        return i2.map((e3, t3, r3) => t3 === r3.length - 1 ? { range: `${e3.quantity}+`, discount: ((parseFloat(l2) - parseFloat(e3.price)) / parseFloat(l2) * 100).toFixed(0) + "%" } : { range: `${e3.quantity}-${r3[t3 + 1].quantity - 1}`, discount: ((parseFloat(l2) - parseFloat(e3.price)) / parseFloat(l2) * 100).toFixed(0) + "%" });
      case "quantityBuyPrice":
        return i2.map((e3) => ({ quantity: "Buy " + e3.quantity, price: parseFloat(e3.price).toFixed(2) }));
      case "quantityPriceDiscount":
        return i2.map((e3) => ({ quantity: e3.quantity, price: parseFloat(e3.price).toFixed(2), discount: ((parseFloat(l2) - parseFloat(e3.price)) / parseFloat(l2) * 100).toFixed(0) + "%" }));
      default:
        return [];
    }
  }, Ye = (e2) => {
    var _a, _b, _c, _d, _e2, _f, _g, _h, _i;
    switch (ke.quantityGridTemplate) {
      case "quantityPrice":
      case "quantityBuyPrice":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: ((_a = ke.quantityGridHeaderText) == null ? void 0 : _a.header1) || "Quantity" }), U("th", { children: ((_b = ke.quantityGridHeaderText) == null ? void 0 : _b.header2) || "Price" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.quantity }), U("td", { children: e3.price })] }, t2)) })] });
      case "quantityRangePrice":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: ((_c = ke.quantityGridHeaderText) == null ? void 0 : _c.header1) || "Quantity Range" }), U("th", { children: ((_d = ke.quantityGridHeaderText) == null ? void 0 : _d.header2) || "Price" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.range }), U("td", { children: e3.price })] }, t2)) })] });
      case "quantityRangeDiscount":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: ((_e2 = ke.quantityGridHeaderText) == null ? void 0 : _e2.header1) || "Quantity Range" }), U("th", { children: ((_f = ke.quantityGridHeaderText) == null ? void 0 : _f.header2) || "Discount" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.range }), U("td", { children: e3.discount })] }, t2)) })] });
      case "quantityPriceDiscount":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: ((_g = ke.quantityGridHeaderText) == null ? void 0 : _g.header1) || "Quantity" }), U("th", { children: ((_h = ke.quantityGridHeaderText) == null ? void 0 : _h.header2) || "Price" }), U("th", { children: ((_i = ke.quantityGridHeaderText) == null ? void 0 : _i.header3) || "Discount" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.quantity }), U("td", { children: e3.price }), U("td", { children: e3.discount })] }, t2)) })] });
      default:
        return null;
    }
  };
}();
